import { render, staticRenderFns } from "./NonInteractableTable.vue?vue&type=template&id=4bb2e4c2&"
import script from "./NonInteractableTable.vue?vue&type=script&lang=ts&"
export * from "./NonInteractableTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports